module.exports = __webpack_public_path__ + "img/add_col_before.8e49a654.svg";